<h3>
  <a *ngIf="this.requestSource" [target]="inPathChanged ? '_blank' : null"
    [carmRouterLink]="inPath" [queryParams]="{ requestSource: this.requestSource }" attr.data-cy="{{inDataCy}}">
    {{inLocalizedTitle}}
  </a>
  <a *ngIf="!this.requestSource" [target]="inPathChanged ? '_blank' : null"
    [carmRouterLink]="inPath" attr.data-cy="{{inDataCy}}">
    {{inLocalizedTitle}}
  </a>
</h3>
<p>
  {{inLocalizedDescription}}
</p>
